Vue.component("jobs-due-today", require("./vue/JobsDueToday.vue"));

window.vue = new Vue({
    el: "#app"
});


// WEBPACK FOOTER //
// ./resources/assets/js/vue.js